import { Http } from '../../../../../../helpers/axois';
import { Content } from './types';
import { Pagination } from './types';

export const api = {
	async getChatContents(appId: string, branchId: string, type: string, pagination: Pagination){
		try {
			const path = baseURL(appId) + `?branchId=${branchId}&type=${type}`+
			(pagination ? 
				`&limit=${pagination.limit}` +
				  (pagination.lastContentId ? `&lastContentId=${pagination.lastContentId}` : '') +
				  (pagination.startTime ? `&startTime=${pagination.startTime}` : '')
			: '');
			const tokens: unknown = await Http.get(path).toPromise();
			return tokens as Content[];
		} catch (err) {
			throw err;
		}
	},
	async getContents(appId: string, branchId: string, type: string) {
		try {
			const path = baseURL(appId) + `?branchId=${branchId}&type=${type}`;
			const tokens: unknown = await Http.get(path).toPromise();
			return tokens as Content[];
		} catch (err) {
			throw err;
		}
	},

	async createContent(appId: string, payload: any) {
		try {
			const path = baseURL(appId);
			const res: any = await Http.post(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async deleteContent(appId: string, branchId: string, contentId: string) {
		try {
			const path = baseURL(appId) + `/${contentId}?branchId=${branchId}`;
			const res: any = await Http.delete(path).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async updateContent(appId: string, contentId: string, payload: any) {
		try {
			const path = baseURL(appId) + `/${contentId}`;
			const res: any = await Http.put(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async getChatContentsByIds(appId: string, branchId: string, contentIds: string[]) {
		const contents = encodeURIComponent(contentIds.join(","))
		try {
			const path = baseURL(appId) + `?branchId=${branchId}&contentIds=${contents}`;
			const tokens: unknown = await Http.get(path).toPromise();
			return tokens as Content[];
		} catch (err) {
			throw err;
		}
	},

	async uploadFile(appId: string, file: File, contentType: string) {
		const path = `/apps/${appId}/chat/uploadFile`
		try {
			const res: any = await Http.post(path, file, {
				headers: {
					"Content-Type": contentType
				}
			}).toPromise();
			return res.url as string
		} catch(err) {
			throw err
		}
	},

	async deleteFile(appId: string, fileUrl: string) {
		const path = `/apps/${appId}/chat/removeFile`
		const data = {
			fileUrl
		}
		try {
			const res = await Http.delete(path, {
				data
			}).toPromise();
			return res
		} catch(err) {
			throw err
		}
	},
};

function baseURL(appId: string) {
	return `/apps/${appId}/chat-contents`;
}
